import React from 'react';
import Header from './components/Header';
import Home from './components/Home';
import GettingStarted from './components/gettingStarted';

import Footer from './components/Footer';
import APIPage from './components/apipage';
import Examples from './components/Examples';
import BasicReactExample from './components/usingWithReact';
import BasicVueExample from './components/usingWithVue'
import TodoAppWithReact from './components/todoAppWithReact';
import TodoAppWithVue from './components/todoAppWithVue';
import { PageNotFound } from './components/PageNotFound';


class  App extends React.Component{
  getCurPage=()=>{
    switch(window.location.pathname){
      case '/':return <Home/>
      case '/get-started' : return <GettingStarted/>
      case '/api':return <APIPage/>
      case '/examples': return <Examples/>
      case '/basic-react-example': return <BasicReactExample/>
      case '/basic-vue-example': return <BasicVueExample/>
      case '/todo-app-with-react-example': return <TodoAppWithReact/>
      case '/todo-app-with-vue-example': return <TodoAppWithVue/>
    }
    return <PageNotFound/>
  }
  render(){
    let curPage=this.getCurPage();
    return <>
      <Header/>{curPage}<Footer/>
    </>
  }
}

export default App;
